import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objToArray'
})
export class ObjToArrayPipe implements PipeTransform {
  transform(value: object): Array<object> {
    return Object.keys(value).map(function(key) {
      const pair = {};
      const k = 'key';
      const v = 'value';

      pair[k] = key;
      pair[v] = value[key];

      return pair;
    });
  }
}
